import { IPermissionsState } from "../reducers/permissionsReducer";

export const selectPermissions = ({ permissions }: IPermissionsState) => permissions.permissions;
